const {select, namespaces} = require("d3-selection");
const {format} = require("d3-format");

const numberFormat = format(",.2");

module.exports = function(target, colorDomain, colorRange) {
  const key = select(target);

  const keySVG = select(document.createElementNS(namespaces.svg, "svg"))
    .attr("width", "100%")
    .attr("height", "35px");
  
  // Width of key rectangles based on number of quantiles, plus 1 for values less
  // than the first quantile
  const keyPct = (100 / (colorDomain.length + 1));
  
  // Add colors to key
  keySVG.selectAll("rect")
    // Add extra bar for values less than first quantile
    .data([].concat(colorDomain[0] - 1, colorDomain))
    .join("rect")
    .attr("x", (d, i) => `${i * keyPct}%`)
    .attr("width", `${keyPct}%`)
    .attr("height", "10px")
    .attr("fill", (d, i) => colorRange[i])
  
  // Add labels to key
  keySVG
    .selectAll("text")
    .data(colorDomain)
    .join("text")
    // Offset by one to label midpoints
    .attr("x", (d, i) => `${(i + 1) * keyPct}%`)
    .attr("text-anchor", "middle")
    .attr("y", "14px")
    .attr("style", "transform: translate(0, 12px)")
    .text(d => `${d !== 0 ? "+" : ""}${d !== 0 ? Math.abs(d) : ""}`);
  
  key.node().appendChild(keySVG.node());
}

// const {select, selectAll} = require("d3-selection");
// const {scaleSequential} = require("d3-scale");
// const {axisBottom} = require("d3-axis");
// const {interpolateRound} = require("d3-interpolate");

// // color is a function that accepts a value from 0-1 and returns a color.
// function ramp(color, n = 256) {
//   const canvas = document.createElement("canvas");
//   const context = canvas.getContext("2d");

//   canvas.width = n;
//   canvas.height = 1;

//   for (let i = 0; i < n; i += 1) {
//     // Color from pct of bar
//     context.fillStyle = color(i / (n - 1));
//     // A 1x1 rect placed at i,0
//     context.fillRect(i, 0, 1, 1);
//   }
//   return canvas;
// }

// module.exports = function(target, colorInterpolator) {
//   const margin = {
//     top: 0,
//     right: 15,
//     bottom: 20,
//     left: 15
//   };

//   const svg = select(document.createElementNS("http://www.w3.org/2000/svg", "svg"))
//     .attr("width", 0)
//     .attr("height", 0);

//   const image = svg.append("image")
//     .attr("preserveAspectRatio", "none")
//     .attr("xlink:href", ramp(colorInterpolator).toDataURL());

//   // const medianLabel = svg.append("text")
//   //   .attr("text-anchor", "middle")
//   //   .attr("y", 10);

//   // const medianLine = svg.append("line")
//   //   .attr("shape-rendering", "crispEdges")
//   //   .attr("stroke", "#000");

//   const x = scaleSequential();

//   const xAxis = axisBottom(x).tickFormat(n => `${n * 100}%`);
//   const xAxisLabels = svg.append("g");

//   target.appendChild(svg.node());

//   function update() {
//     const width = target.offsetWidth;
//     const height = target.offsetHeight;

//     svg
//       .attr("width", width)
//       .attr("height", height);

//     image
//       .attr("x", margin.left)
//       .attr("y", margin.top)
//       .attr("width", width - margin.left - margin.right)
//       .attr("height", height - margin.top - margin.bottom)

//     x.interpolator(interpolateRound(margin.left, width - margin.right));

//     // medianLine
//     //   .attr("x1", d => x(d))
//     //   .attr("x2", d => x(d))
//     //   .attr("y1", margin.top - 6)
//     //   .attr("y2", height - margin.bottom);

//     // medianLabel.attr("x", d => x(d));

//     xAxisLabels
//       .attr("transform", `translate(0,${height - margin.bottom})`)
//       .call(xAxis)
//       .call(g => g.selectAll(".tick line").attr("y1", margin.top + margin.bottom - height));
//   }

//   function updateAxis(range, tickFormat = n => `${n * 100}%`) {
//     // x.domain(range);
//     xAxis.tickValues(range).tickFormat(tickFormat);
//     // medianLabel.text(`Median: ${median}%`);
//     // medianLine.datum(median);
//     // medianLabel.datum(median);

//     update();
//   }

//   // update();
//   // window.addEventListener("resize", update);

//   return updateAxis;
// }

